// import {HTTPServer} from '@/common/js/ajax'
import * as types from '../mutations-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  currentSelBean: {},
  sourceSelBean: {},
  sourceModuleList: [],
  dashIsAdd: false,
  isChange: false,
  isChangeSource: false, // 是否通过手动改变时数据源
  isChartPage: false,
  // dashId: {} // 当前编辑仪表盘ID
  currentField: '',
  isDrag: false, // 字段是否在拖动
  /** **********************************************************************新改版 */
  currentChartType: '', // 符合字段类型的图表
  chooseBean: '', // 当前数据源
  currentFields: [], // 当前字段
  currentChart: '', // 当前的图标类型
  temChartOption: {}, // 暂存当前图表设置
  currentChartIndex: null,
  allAnaylystData: {},
  currentDaId: '', // 当前数据分析图表
  isChartChange: 0, // 图表发生改变
  dataSource: {}, // 数据源是否发生改变
  fromToMain2: {}, // 缓存从首页跳到设计界面的数据，用于判断数据是否有更改
  isEmpty: false
}

// getters
const getters = {
  // getChartOption: state => state.checkoutStatus,
  // getChartOption: (state, getters, rootState) => {
  //   return state.added.map(({ id, quantity }) => {
  //     const product = rootState.products.all.find(product => product.id === id)
  //     return {
  //       title: product.title,
  //       price: product.price,
  //       quantity
  //     }
  //   })
  // },
  getSingleChartOption: (state, getters) => index => {
    return state.allAnaylystData.chartSet[index]
  },
  getChartTitleList: (state, getters) => {
    let titleList = []
    state.allAnaylystData.chartSet &&
      state.allAnaylystData.chartSet.map((item, index) => {
        let obj = { source: item.source.sourceModule, title: item.chartProps.title }
        titleList.push(obj)
      })
    return titleList
  }
}
// actions
const actions = {
  // getInitCondition: ({ commit, state }) => {
  //   HTTPServer.getInitCondition(state.currentBean)
  //   .then((res) => {
  //     commit('SET_CONDITIONS', res)
  //   })
  // },
  // getAllFieldList: ({commit, state}) => {
  //   HTTPServer.getAllFieldList(state.currentBean)
  //   .then((res) => {
  //     commit('SET_ALL_FIELDS', res)
  //   })
  // }
  // setModuleBean: ({commit, state}, {sourceParams}) => {
  //   commit('SWITCH_SOURCE_BEAN', sourceParams)
  // }
}

// mutations
const mutations = {
  [types.SET_FROM_TO_MAIN](state, maindata) {
    state.fromToMain2 = maindata
  },
  [types.SWITCH_CURRENT_BEAN](state, currentBean) {
    state.currentSelBean = currentBean
  },
  [types.SWITCH_SOURCE_BEAN](state, sourceBean) {
    state.sourceSelBean = sourceBean
  },
  [types.SWITCH_SOURCE_LIST](state, sourceList) {
    state.sourceModuleList = sourceList
  },
  [types.CHANGE_CURRENT_BEAN](state, isChange) {
    state.isChangeSource = isChange
  },
  [types.CHART_PAGE](state, status) {
    state.isChartPage = status
  },
  [types.SET_CURRENT_FIELD](state, fields) {
    state.currentField = fields
  },
  [types.SET_IS_DRAG](state, isDrag) {
    state.isDrag = isDrag
  },
  /** 新改版******************************************************************************************************* */
  [types.SET_CURRENT_TYPE](state, type) {
    state.currentChartType = type
  },
  [types.SET_CHOOSE_BEAN](state, bean) {
    state.chooseBean = bean
  },
  [types.SET_CURRENT_FIELDS](state, fieldsArr) {
    state.currentFields = fieldsArr
  },
  [types.SET_CURRENT_CHART](state, chart) {
    state.currentChart = chart
  },
  [types.SET_CHART_OPTION](state, option) {
    // let isEixt = state.allAnaylystData.chartSet.some((item, index) => {
    //   return cha
    // })
    if (state.allAnaylystData.chartSet.length > 0) {
      state.allAnaylystData.chartSet.map((item, index) => {
        if (item.chartId === option.chartId) {
          item = option
        } else {
          state.allAnaylystData.chartSet.push(option)
        }
      })
    } else {
      state.allAnaylystData.chartSet.push(option)
    }
  },
  [types.SET_ALL_CHART](state, alldata) {
    state.allAnaylystData = alldata
  },
  [types.SET_CURRENT_DA_ID](state, id) {
    state.currentDaId = id
  },
  [types.SET_CHART_CHANGE](state, boole) {
    state.isChartChange += boole
  },
  [types.SET_SOURCE](state, source) {
    state.dataSource = source
  },
  [types.SET_IS_EMPTY](state, boole) {
    state.isEmpty = boole
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
